import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCTextInput from '../../components/Simple/SMCTextInput';
import SMCModal from '../../components/core/SMCModal';
import Api from '../../api/SMPFetchHelper';
import {useSMCErrorHandler} from '../../utils/errorUtils';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {isNumeric} from '../../utils/utils';
import SMCLabel from '../../components/Simple/SMCLabel';

function AddFirmwareToPortalModal({
    isOpen,
    onRequestClose,
    onSuccess
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();

    const [firmwareId, setFirmwareId] = useState('');
    const [isAddingFirmware, setIsAddingFirmware] = useState(false);
    const [isDone, setIsDone] = useState(false);

    const onFinish = async () => {
        if (isDone) {
            onSuccess && onSuccess();
        }
        else if (!firmwareId || !isNumeric(firmwareId)) {
            alert(t('SMC_FIRMWARE_TYPE_PRIVATE_FIRMWARE_ALERT1'));
        }
        else {
            setIsAddingFirmware(true);
            Api.addPrivateFirmwareToThisPortal(firmwareId)
                .then(() => {
                    setIsDone(true);
                })
                .catch(e => {
                    alert(getErrorMessage(e));
                })
                .finally(() => {
                    setIsAddingFirmware(false);
                });
        }
    }

    // On each new open, reset values
    useEffect(() => {
        if (isOpen) {
            setFirmwareId('');
        }
    }, [isOpen]);


    return (
        <SMCModal
            loading={isAddingFirmware}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={850}
            height={700}
            title={t('SMC_FIRMWARE_TYPE_PRIVATE_ADD_CUST_HOTFIX')}
        >
            <SMCModalBody>
                {
                    isDone && (
                        <SMCLabel>Succesfuly added firmware</SMCLabel>
                    )
                }
                {
                    !isDone && (
                        <>
                        <SMCLabel bold fontSize="16px">Enter Customer Hotfix Firmware ID:</SMCLabel>
                        <SMCTextInput
                            value={firmwareId}
                            onChange={e => setFirmwareId(e.target.value)}
                            label={t('SMC_FIRMWARE_TYPE_PRIVATE_FIRMWARE_ID')}
                            tooltip={t('SMC_FIRMWARE_TYPE_PRIVATE_FIRMWARE_ID_TOOLTIP')}
                        />
                        </>
                    )
                }
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default AddFirmwareToPortalModal;